import { Link } from "react-router-dom";
import { Sparkles, X, Zap } from "lucide-react";

/**
 * Non-blocking upsell shown when a Free user is ≥80% through any quota.
 * `nudge` shape: { key, label, used, limit, pct }
 */
export default function UpgradeNudge({ nudge, onDismiss }) {
  if (!nudge) return null;
  const verb = nudge.label === "brands" ? "adding sponsors"
             : nudge.label === "media kits" ? "generating media kits"
             : "sending outreach";
  const body = nudge.pct >= 1
    ? `You've hit your Free plan limit. Upgrade to Pro to keep ${verb} without interruption.`
    : `You're at ${Math.round(nudge.pct * 100)}% of your Free plan limit. Upgrade to Pro for higher caps and unlimited essentials.`;

  return (
    <div className="surface p-5 mb-6 border-volt/60 bg-volt/5 flex items-start gap-4"
         data-testid="dashboard-upgrade-nudge">
      <div className="w-10 h-10 border border-volt/60 flex items-center justify-center flex-shrink-0">
        <Zap className="w-5 h-5 text-volt" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-heading text-lg uppercase tracking-tight" data-testid="upgrade-nudge-title">
          You've used {nudge.used} of {nudge.limit} {nudge.label}
        </div>
        <p className="text-sm text-ink-muted mt-1">{body}</p>
        <div className="flex gap-2 mt-3 flex-wrap">
          <Link to="/app/pricing" className="btn-volt inline-flex items-center gap-2 text-xs" data-testid="upgrade-nudge-cta">
            <Sparkles className="w-3.5 h-3.5" /> See Pro plans
          </Link>
          <button onClick={onDismiss} className="btn-ghost-line text-xs" data-testid="upgrade-nudge-dismiss">
            Maybe later
          </button>
        </div>
      </div>
      <button onClick={onDismiss} className="text-ink-muted hover:text-white p-1"
              aria-label="Dismiss" data-testid="upgrade-nudge-close">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
